import React, { useState, useEffect, useContext } from "react";
import Paper from "@mui/material/Paper";
import { Template, TemplatePlaceholder } from "@devexpress/dx-react-core";
import {
    Grid,
    Table,
    TableHeaderRow,
    TableFilterRow,
    PagingPanel,
    TableColumnResizing,
    Toolbar,
    TableColumnVisibility,
    ColumnChooser,
} from "@devexpress/dx-react-grid-material-ui";

import {
    IntegratedFiltering,
    FilteringState,
    SortingState,
    PagingState,
    IntegratedPaging,
    IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
    getDeviceProfiles,
    saveDeviceProfile,
} from "../../services/RepositoryService";
import Spinner from "../../components/Spinner";
import StarekContext from "../../context/StarekContext";
import { useNavigate } from "react-router-dom";
import AddDeviceProfileWizard from "../../components/Wizards/AddDeviceProfileWizard";

const TableCell = (props) => {
    const { row, column } = props;
    const navigator = useNavigate();
    if (column.name === "name") {
        return (
            <Table.Cell
                {...props}
                onClick={() => {
                    navigator(`/device-profiles/${row.id}`);
                }}
            >
                <a href="#">{row.name}</a>
            </Table.Cell>
        );
    }
    return <Table.Cell {...props} />;
};

const DeviceProfiles = (props) => {
    const context = useContext(StarekContext);
    const navigator = useNavigate();
    const [items, setItems] = useState();
    const [selected, setSelected] = useState();
    const [isAdding, setIsAdding] = useState(false);
    const [loadingPrimary, setLoadingPrimary] = useState(true);
    const [columns, setColumns] = useState([
        { name: "name", title: "Name" },
        { name: "description", title: "Description" },
        { name: "model_id", title: "Applies To" },
    ]);

    const [pageSizes] = useState([5, 10, 20]);
    const [defaultColumnWidths] = useState([
        { columnName: "name", width: 250 },
        { columnName: "description", width: 250 },
        { columnName: "model_id", width: 250 },
    ]);
    const [defaultHiddenColumnNames] = useState([{ columnName: "name" }]);
    const [tableColumnExtensions] = useState([]);
    const [showFilter] = useState(false);
    const hiddenColumns = [{ columnName: "name" }];

    const loadDeviceProfiles = async () => {
        try {
            const deviceProfiles = await getDeviceProfiles(
                context.activePlant.id
            );
            setItems(deviceProfiles);
        } catch (error) {
            context.showErrorMessage(error.message);
        }
        setLoadingPrimary(false);
    };
    useEffect(() => {
        (async () => {
            await loadDeviceProfiles();
        })();
    }, []);

    return loadingPrimary ? (
        <>
            <Spinner />
            <div className="text-xs d-flex justify-content-center">
                <i className="fa fa-industry fa-10x"></i>
            </div>
        </>
    ) : (
        <div>
            {items && (
                <div>
                    {items && (
                        <div>
                            <br />
                            <br />
                            <Paper>
                                <Grid
                                    rows={items}
                                    columns={columns}
                                    getRowId={(row) => row.id}
                                >
                                    {showFilter && <FilteringState />}
                                    <SortingState />
                                    <PagingState
                                        defaultCurrentPage={0}
                                        defaultPageSize={pageSizes[1]}
                                    />
                                    {showFilter && <IntegratedFiltering />}
                                    <IntegratedSorting />
                                    <IntegratedPaging />
                                    <Table
                                        columnExtensions={tableColumnExtensions}
                                        cellComponent={TableCell}
                                    />
                                    <TableColumnVisibility
                                        defaultHiddenColumnNames={
                                            defaultHiddenColumnNames
                                        }
                                    />
                                    <TableColumnResizing
                                        defaultColumnWidths={
                                            defaultColumnWidths
                                        }
                                    />
                                    <TableHeaderRow showSortingControls />
                                    {showFilter && <TableFilterRow />}
                                    <Toolbar />
                                    <Template name="toolbarContent">
                                        <TemplatePlaceholder />
                                        <div
                                            className="btn btn-primary"
                                            onClick={() => {
                                                setIsAdding(true);
                                            }}
                                        >
                                            Add Device Profile
                                        </div>
                                    </Template>
                                    <ColumnChooser
                                        hiddenColumnNames={hiddenColumns}
                                    />
                                    <PagingPanel pageSizes={pageSizes} />
                                </Grid>
                            </Paper>
                        </div>
                    )}
                </div>
            )}
            {isAdding && (
                <AddDeviceProfileWizard
                    onClose={(event) => {
                        console.log("close", event.detail.manifest);
                        setIsAdding(false);
                    }}
                    onFinish={async (event) => {
                        await saveDeviceProfile(
                            context.activePlant.id,
                            event.detail.manifest
                        );
                        setIsAdding(false);
                        await loadDeviceProfiles();
                    }}
                ></AddDeviceProfileWizard>
            )}
        </div>
    );
};

export { DeviceProfiles };
